import React from "react";
const brandVoucherImage =
  "https://res.cloudinary.com/dyyjph6kx/image/upload/v1638764214/store/admin/Image.png";

import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";

import styled from "styled-components";
import theme from "../../../theme";
import { Button } from "@plum-xoxo/admin-dsm";
import EditMask from "./EditMask";

const StyledDiv = styled.div`
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;
const DividerDiv = styled.div`
  padding: 16px 0 0;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const BorderDiv = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const RewardDiv = styled.div`
  width: 40%;
  padding: 12px 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const PointsDiv = styled.div`
  width: 40%;
  padding: 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const WorthDiv = styled.div`
  width: 30%;
  padding: 14px 0 14px 32px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const ExpiryDiv = styled.div`
  width: 30%;
  padding: 14px 0 14px 32px;
`;
const ValidityDiv = styled.div`
  width: 30%;
  padding: 20px 0 20px 32px;
`;

const XoxoCodeRewardBody = ({
  currencyCode = "INR",
  validTill,
  toggleTextModal,
  buttonText,
}) => {
  return (
    <>
      <div className="text-center">
        <Typography.BodySmall className="mb-8" color="dark" shade="c200">
          Reward Codes worth
        </Typography.BodySmall>
        <Typography.DisplayText color="dark" shade="c300">
          {currencyCode} *****
        </Typography.DisplayText>
        <div
          style={{
            border: `1px dashed ${theme.palette.dark.c000}`,
            borderRadius: "8px",
          }}
          className="py-16 px-12 mb-16"
        >
          <Typography.BodySmall color="dark" shade="c200">
            Use this code
          </Typography.BodySmall>
          <Typography.ButtonText
            color="dark"
            shade="c300"
            className="mt-4 mb-24"
          >
            ****-****-****-****
          </Typography.ButtonText>
          <Typography.BodySmall color="dark" shade="c200" component="div">
            Expires on {validTill}
          </Typography.BodySmall>
        </div>
        <div className="position-relative">
          <Button size="large" className="w-100 ">
            {buttonText}
          </Button>
          <EditMask
            buttonText="Button Text"
            top={0}
            toggleModalState={() => toggleTextModal()}
          />
        </div>
      </div>
    </>
  );
};

export default XoxoCodeRewardBody;
